import { App } from '../enums/app.enum';
import { AppColors } from './app-colors.const';
import { AppRoles } from './app-roles.const';
import { AppMenuPoint } from '../interfaces/app-menupoint.interface';

export const AppMenuPoints: AppMenuPoint[] = [
	{
		name: App.my,
		image: 'assets/images/logo-world.svg',
		darkImage: 'assets/images/logo-world-inverted.svg',
		imageSmall: 'assets/images/pikto-world.svg',
		roles: AppRoles[App.my],
		color: AppColors[App.my],
	},
	{
		name: App.analytics,
		image: 'assets/images/logo-analytics.svg',
		darkImage: 'assets/images/logo-analytics-inverted.svg',
		imageSmall: 'assets/images/pikto-analytics.svg',
		roles: AppRoles[App.analytics],
		color: AppColors[App.analytics],
	},
	{
		name: App.academy,
		image: 'assets/images/logo-academy.svg',
		darkImage: 'assets/images/logo-academy-inverted.svg',
		imageSmall: 'assets/images/pikto-academy.svg',
		beta: true,
		roles: AppRoles[App.academy],
		color: AppColors[App.academy],
	},
	{
		name: App.docs,
		image: 'assets/images/logo-docs.svg',
		darkImage: 'assets/images/logo-docs-inverted.svg',
		imageSmall: 'assets/images/pikto-docs.svg',
		roles: AppRoles[App.docs],
		color: AppColors[App.docs],
		newTab: false,
	},
	{
		name: App.lifecycle,
		image: 'assets/images/logo-lifecycle.svg',
		darkImage: 'assets/images/logo-lifecycle-inverted.svg',
		imageSmall: 'assets/images/pikto-lifecycle.svg',
		roles: AppRoles[App.lifecycle],
		color: AppColors[App.lifecycle],
	},
	{
		name: App.plan,
		image: 'assets/images/logo-plan.svg',
		darkImage: 'assets/images/logo-plan-inverted.svg',
		imageSmall: 'assets/images/pikto-plan.svg',
		roles: AppRoles[App.plan],
		color: AppColors[App.plan],
	},
	{
		name: App.selftest,
		image: 'assets/images/logo-selftest.svg',
		darkImage: 'assets/images/logo-selftest-inverted.svg',
		imageSmall: 'assets/images/pikto-selftest.svg',
		roles: AppRoles[App.selftest],
		color: AppColors[App.selftest],
	},
	{
		name: App.manage,
		image: 'assets/images/logo-manage.svg',
		darkImage: 'assets/images/logo-manage-inverted.svg',
		imageSmall: 'assets/images/pikto-manage.svg',
		roles: AppRoles[App.manage],
		color: AppColors[App.manage],
	},
];
